import React, { useCallback, useState } from "react";

import CustomInput from "components/newForm/CustomInput";
import CustomToolip from "./CustomToolip";
import CustomTooltipMobile from "./CustomTooltipMobile";
import { BsKey, BsPersonBadge, BsPersonCircle } from "react-icons/bs";
import {
  Container,
  Form,
  ToolTipIcon,
  TooltipIconMobile,
  TooltipWrap,
} from "./styles";
import { GoHome } from "react-icons/go";
import { useMediaQuery } from "react-responsive";

import type { RegistrationDataProps } from "./types";

const RegistrationData: React.FC<RegistrationDataProps> = ({
  corporateName,
  shipToAddress,
  shipLetterToAddress,
  customerCode,
  document,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const showMobileMode = useMediaQuery({ maxWidth: 769 });

  const handleShowTooltip = useCallback(() => {
    setShowTooltip((prev) => !prev);
  }, [showTooltip]);

  return (
    <Container>
      <Form>
        <CustomInput
          disabled
          icon={BsPersonCircle}
          id="fullName"
          name="fullName"
          inputType="text"
          labelText="Nome completo"
          value={corporateName}
        />
        <CustomInput
          disabled
          icon={BsPersonBadge}
          id="document"
          name="document"
          inputType="text"
          labelText="CPF/CNPJ"
          value={document}
        />
        <CustomInput
          disabled
          icon={BsKey}
          id="codCli"
          name="codCli"
          inputType="text"
          labelText="Código do cliente"
          value={customerCode}
        />
        <CustomInput
          disabled
          icon={GoHome}
          id="endEntrega"
          name="endEntrega"
          inputType="text"
          labelText="Endereço da unidade"
          value={shipToAddress}
        />
        <TooltipWrap>
          <CustomInput
            disabled
            icon={GoHome}
            id="endCorrespondencia"
            name="endCorrespondencia"
            inputType="text"
            labelText="Endereço de correspondência"
            value={shipLetterToAddress}
          />
          {!showMobileMode && (
            <CustomToolip
              title="Endereço de correspondência"
              className="tooltip-address"
            >
              <ToolTipIcon>i</ToolTipIcon>
            </CustomToolip>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            {showMobileMode && (
              <div
                style={{
                  display: "flex",
                }}
                onClick={handleShowTooltip}
              >
                <TooltipIconMobile>!</TooltipIconMobile>
              </div>
            )}
            {showMobileMode && showTooltip && <CustomTooltipMobile />}
          </div>
        </TooltipWrap>
      </Form>
    </Container>
  );
};

export default RegistrationData;
